import { render } from "./cdrBatchList.vue?vue&type=template&id=f8573c32&scoped=true"
import script from "./cdrBatchList.vue?vue&type=script&lang=js"
export * from "./cdrBatchList.vue?vue&type=script&lang=js"

import "./cdrBatchList.vue?vue&type=style&index=0&id=f8573c32&scoped=true&lang=css"
import "./cdrBatchList.vue?vue&type=style&index=1&id=f8573c32&lang=css"
script.render = render
script.__scopeId = "data-v-f8573c32"

export default script